import { Fragment } from "react"
import BackDropModal from "../backDropModal"
import ReactDOM from "react-dom"
import { useRequestProcessor } from "../../../api/requestProcessor"
import { getSingleBlog } from "../../../api/blogs"
import { getSingleOrder } from "../../../api/orders"


const ViewBlogComponent = ({ data, onConfirm }) => {

    const { Query } = useRequestProcessor()

    const { data: orderData } = Query(
        ['getSignleOrder', data.id],
        () => getSingleOrder(data.id)
    );


    return (
        <div key={data.id} className="fixed top-[5%] left-[4%] z-10">
            <div className="w-[1400px] py-6 px-4 flex-col rounded-2xl bg-white h-1/2 font-bold ">
                <div className="flex justify-between items-center border-b py-2">
                    <h1 className="text-[1rem] font-bold">مشخصات پرداخت {data.title}</h1>
                    <div onClick={() => onConfirm()}>X</div>
                </div>
                <div className="flex-col items-center my-5">
                    <table className="table-auto transition-all" >
                        <thead className="!py-2">
                            <tr className=" border-b border-black text-sm">
                                <th className="py-3">#</th>
                                <th className="py-3">مشخصات کاربر</th>
                                <th className="py-3">مشخصات سازنده</th>
                                <th className="py-3">مقدار تخفیف</th>
                                <th className="py-3">شماره تخفیف</th>
                                <th className="py-3">قیمت کلی</th>
                                <th className="py-3">تاریخ ایجاد</th>
                                <th className="py-3">تاریخ بروزرسانی</th>
                                <th className="py-3">درگاه پرداخت</th>
                                <th className="py-3">نوع پرداخت</th>
                                <th className="py-3">وضعیت پرداخت</th>
                                <th className="py-3">پرداخت</th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr key={orderData?.data.id} className="text-[#575757]  hover:bg-[#fafafa]"  >
                                <td className="text-center py-5" >{orderData?.data.id}</td>
                                <td className="text-center text-sm py-5" >
                                    {orderData?.data?.user_id?.id}.  {orderData?.data?.user_id?.name + " " + orderData?.data?.user_id?.lastname}
                                </td>
                                <td className="text-center text-sm py-5" >
                                    {orderData?.data?.creator_id?.id}.  {orderData?.data?.creator_id?.name + " " + orderData?.data?.creator_id?.lastname}
                                </td>
                                {/* <td className="text-center py-5" >
                                    {orderData?.data.creator_id}
                                </td> */}
                                <td className="text-center py-5" >
                                    {orderData?.data.discount_amount}
                                </td>
                                <td className="text-center py-5" >
                                    {orderData?.data.discount_id ?? "-"}
                                </td>
                                <td className="text-center py-5" >
                                    {orderData?.data.total_price.toLocaleString()}
                                </td>

                                <td className="text-center py-5" >
                                    <p>{orderData?.data.created_at?.split(" ")[0]}</p>
                                    <p>{orderData?.data.created_at?.split(" ")[1]}</p>
                                </td>
                                <td className="text-center py-5" >
                                    <p>{orderData?.data.updated_at?.split(" ")[0]}</p>
                                    <p>{orderData?.data.updated_at?.split(" ")[1]}</p>
                                </td>

                                <td className="text-center py-5" > {orderData?.data.payment_gate}</td>
                                <td className="text-center py-5" > {orderData?.data.type}</td>
                                <td className="text-center py-5" > {orderData?.data.status}</td>
                                <td className="text-center py-5" > {orderData?.data.is_paid}</td>

                            </tr>

                        </tbody>
                    </table>
                </div>
                {
                    orderData?.data?.order_item.length ?
                        <div className="flex-col border-t pt-2 my-5">
                            <h3 className="text-lg">سفارشات :</h3>
                            <table className="table-auto transition-all" >
                                <thead className="!py-2">
                                    <tr className=" border-b border-black text-sm">
                                        <th className="py-3">#</th>
                                        <th className="py-3">قیمت</th>
                                        <th className="py-3">تعداد</th>
                                        <th className="py-3">شماره سفارش</th>
                                        <th className="py-3">تاریخ ایجاد</th>
                                        <th className="py-3">مشخصات خریداری شده</th>
                                        <th className="py-3">نوع خریداری شده</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        orderData?.data?.order_item.length ?
                                            orderData?.data?.order_item.map(el => (
                                                <tr key={el.id} className="text-[#575757] border-b border-[#d5d5d5] hover:bg-[#fafafa]"  >
                                                    <td className="text-center py-5" >{el.id}</td>
                                                    <td className="text-center py-5" >{el.price}</td>
                                                    <td className="text-center py-5" >
                                                        {el.quantity}
                                                    </td>
                                                    <td className="text-center py-5" >
                                                        {el.order_id}
                                                    </td>

                                                    <td className="text-center py-5" >
                                                        <p>{el.created_at?.split(" ")[0]}</p>
                                                        <p>{el.created_at?.split(" ")[1]}</p>
                                                    </td>
                                                    <td className="text-center text-sm py-5" >
                                                        {el.item_name?.id + ". " + el.item_name?.title}
                                                    </td>
                                                    <td className="text-center py-5" >
                                                        {el.itemable_type}
                                                    </td>
                                                </tr>
                                            ))
                                            :
                                            <div>
                                                <p>هیچ سفارشی پیدا نشد</p>
                                            </div>
                                    }
                                </tbody>
                            </table>
                        </div>
                        : <></>
                }

                {
                    orderData?.data?.order_item[0]?.ticket?.data?.length ?
                        <div className="flex flex-col ">
                            <h3>تیکت های مربوط به سفارش</h3>
                            <table className="table-auto transition-all" >
                                <thead className="!py-2">
                                    <tr className=" border-b border-black">
                                        <th className="py-3">#</th>
                                        <th className="py-3">مشخصات سازنده</th>
                                        <th className="py-3">مشخصات کاربر</th>
                                        <th className="py-3">آیدی ورک شاپ</th>
                                        <th className="py-3">وضعیت</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {
                                        orderData?.data?.order_item[0]?.ticket?.data.map(el => (
                                            <tr key={el.id} className="text-[#575757] border-b border-[#d5d5d5] hover:bg-[#fafafa]"  >
                                                <td className="text-center py-5" >{el.id}</td>
                                                <td className="text-center text-sm py-5" > {el.creator?.id}. {el.creator?.name + el.creator?.lastname}</td>
                                                <td className="text-center text-sm py-5" > {el.user?.id}. {el.user?.name + el.user?.lastname}</td>
                                                <td className="text-center py-5" > {el.workshop_id}</td>
                                                <td className="text-center py-5" > {el.state ? "فعال" : "غیر فعال"}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                        :
                        <></>
                }
            </div>
        </div>
    )
}


const ViewOrderModal = ({ onConfirm, data }) => {
    return (
        <Fragment>
            {ReactDOM.createPortal(<BackDropModal onConfirm={onConfirm} />, document.getElementById("backdrop-root"))}
            {ReactDOM.createPortal(<ViewBlogComponent data={data} onConfirm={onConfirm} />, document.getElementById("modal-root"))}
        </Fragment>
    )
}


export default ViewOrderModal